module.exports = __webpack_public_path__ + "static/img/girl.8fbb1662.png";